export default "__VITE_ASSET__TdbXuHkz__"